import { render } from "./search-alternative-locations.vue?vue&type=template&id=15dd087c&scoped=true"
import script from "./search-alternative-locations.vue?vue&type=script&lang=js"
export * from "./search-alternative-locations.vue?vue&type=script&lang=js"

import "./search-alternative-locations.vue?vue&type=style&index=0&id=15dd087c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dd087c"]])

export default __exports__